import React, { forwardRef } from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

import { LoadingRoundIcon as LoadingIcon, SearchIcon } from '../Icon'
import { InlineBox } from '../Grid'

const Wrapper = styled(InlineBox)`
  position: relative;

  > span {
    pointer-events: none;
    position: absolute;
  }

  input {
    box-sizing: border-box;
    padding-left: 35px;
    width: 100%;

    ::placeholder {
      opacity: 1;
    }

    :focus {
      outline-width: 2px;
      outline-style: solid;
      outline-color: ${props => props.theme.colors.blue300};
    }
    &::-webkit-search-cancel-button {
      width: 16px;
      height: 16px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23747474' fill-rule='evenodd' d='M8 .2a7.8 7.8 0 1 0 0 15.6A7.8 7.8 0 1 0 8 .2ZM6.624 5.776a.6.6 0 1 0-.848.848L7.152 8 5.776 9.376a.6.6 0 1 0 .848.848L8 8.848l1.376 1.376a.6.6 0 1 0 .848-.848L8.848 8l1.376-1.376a.6.6 0 1 0-.848-.848L8 7.152 6.624 5.776Z' clip-rule='evenodd'/%3E%3C/svg%3E");
      cursor: pointer;
      transition: opacity 0.2s ease-in-out;
      &:hover {
        opacity: 0.85;
      }
    }
  }
`

const Search = forwardRef(function Search(
  { className, onChange, fontSize = '14px', placeholder = 'Search', loading, ...props },
  ref
) {
  const classes = classNames(className, 'form__text_input')

  const updateSearch = e => {
    onChange && onChange(e.target.value)
  }

  return (
    <Wrapper fontSize={fontSize} {...props}>
      {loading ? (
        <InlineBox as="span" mt="11px" ml="10px">
          <LoadingIcon color="light-dark(var(--brand-grey-200), var(--brand-grey-400))" />
        </InlineBox>
      ) : (
        <InlineBox as="span" mt="8px" ml="10px">
          <SearchIcon color="light-dark(var(--brand-grey-200), var(--brand-grey-400))" />
        </InlineBox>
      )}
      <input
        name="search"
        ref={ref}
        type="search"
        className={classes}
        onChange={updateSearch}
        placeholder={placeholder}
        autoComplete="off"
      />
    </Wrapper>
  )
})

export default Search
